export class TrackVariable {
	public id: number
	public name: string
	public type: string
	public strength?: number

	constructor(data: {
		id: number
		name: string
		type: string
		strength?: number
	}) {
		this.id = data.id
		this.name = data.name
		this.type = data.type
		this.strength = data.strength
	}

	static create(data: Partial<TrackVariable>) {
		const defaultData = {
			id: 0,
			name: '',
			type: '',
			strength: 0,
		}

		return new TrackVariable({
			...defaultData,
			...data,
		})
	}
}
